export type ThemePreference = "light" | "dark" | "system";
export type ResolvedThemeMode = "light" | "dark";

export function isThemePreference(
  value: string | undefined
): value is ThemePreference {
  const normalized = value?.trim().toLowerCase();
  return normalized === "light" || normalized === "dark" || normalized === "system";
}

export function normalizeThemePreference(
  value: string | undefined,
  fallback: ThemePreference = "system"
): ThemePreference {
  const normalized = value?.trim().toLowerCase();
  if (isThemePreference(normalized)) {
    return normalized;
  }

  return fallback;
}

export function resolveThemeMode(
  preference: ThemePreference,
  systemPrefersDark: boolean
): ResolvedThemeMode {
  if (preference === "dark") {
    return "dark";
  }

  if (preference === "light") {
    return "light";
  }

  return systemPrefersDark ? "dark" : "light";
}

export function readThemePreferenceFromCookie(
  defaultPreference: ThemePreference = "system"
): ThemePreference {
  if (typeof document === "undefined") {
    return defaultPreference;
  }

  try {
    const match = document.cookie.match(/(?:^|; )theme=([^;]*)/);
    const value = match ? decodeURIComponent(match[1]) : undefined;

    return normalizeThemePreference(value, defaultPreference);
  } catch {
    return defaultPreference;
  }
}

export function systemPrefersDarkMode(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}
